/**
 * Converts a dictionary-like object to a FormData object.
 */
export function objectToFormData(object: { [key: string]: any }): FormData
{
    let formData = new FormData();

    for (let key of Object.keys(object))
    {
        let value = object[key];

        if (typeof value === "string")
        {
            formData.set(key, value);
        }
        else if (typeof value === "object")
        {
            // Assume Blob.
            formData.set(key, value);
        }
        else if (typeof value === "number")
        {
            formData.set(key, value.toString());
        }
        else if (typeof value === "boolean")
        {
            formData.set(key, value.toString());
        }
        else
        {
            console.warn(`objectToFormData: Only string, number, Blob, and boolean values are supported in source object. '${key}' will be ignored.`);
        }
    }

    return formData;
}
